const actions = {
  CREATE_SALE_ACTIVITY: 'CREATE_SALE_ACTIVITY',
  CREATE_SALE_ACTIVITY_ENDED: 'CREATE_SALE_ACTIVITY_ENDED',
  UPDATE_SALE_ACTIVITY: 'UPDATE_SALE_ACTIVITY',
  UPDATE_SALE_ACTIVITY_ENDED: 'UPDATE_SALE_ACTIVITY_ENDED',
  DELETE_SALE_ACTIVITIES: 'DELETE_SALE_ACTIVITIES',
  DELETE_SALE_ACTIVITIES_ENDED: 'DELETE_SALE_ACTIVITIES_ENDED',
  SEARCH_SALE_ACTIVITIES: 'SEARCH_SALE_ACTIVITIES',
  SEARCH_SALE_ACTIVITIES_ENDED: 'SEARCH_SALE_ACTIVITIES_ENDED',
  FIND_SALE_ACTIVITY_CATEGORY: 'FIND_SALE_ACTIVITY_CATEGORY',
  FIND_SALE_ACTIVITY_CATEGORY_ENDED: 'FIND_SALE_ACTIVITY_CATEGORY_ENDED',
  FIND_SALE_ACTIVITY: 'FIND_SALE_ACTIVITY',
  FIND_SALE_ACTIVITY_ENDED: 'FIND_SALE_ACTIVITY_ENDED',
  CREATE_SALE_ACTIVITY_CATEGORY: 'CREATE_SALE_ACTIVITY_CATEGORY',
  CREATE_SALE_ACTIVITY_CATEGORY_ENDED: 'CREATE_SALE_ACTIVITY_CATEGORY_ENDED',
  UPDATE_SALE_ACTIVITY_CATEGORY: 'UPDATE_SALE_ACTIVITY_CATEGORY',
  UPDATE_SALE_ACTIVITY_CATEGORY_ENDED: 'UPDATE_SALE_ACTIVITY_CATEGORY_ENDED',
  DELETE_SALE_ACTIVITY_CATEGORIES: 'DELETE_SALE_ACTIVITY_CATEGORIES',
  DELETE_SALE_ACTIVITY_CATEGORIES_ENDED: 'DELETE_SALE_ACTIVITY_CATEGORIES_ENDED',
  SEARCH_SALE_ACTIVITY_CATEGORIES: 'SEARCH_SALE_ACTIVITY_CATEGORIES',
  SEARCH_SALE_ACTIVITY_CATEGORIES_ENDED: 'SEARCH_SALE_ACTIVITY_CATEGORIES_ENDED',
  GET_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION: 'GET_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION',
  GET_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION_ENDED:
    'GET_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION_ENDED',
  UPDATE_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION:
    'UPDATE_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION',
  UPDATE_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION_ENDED:
    'UPDATE_SALE_ACTIVITY_HANDLING_FEE_CONFIGURATION_ENDED',
  GET_SALE_ACTIVITY_RECEIPT_CONFIGURATION: 'GET_SALE_ACTIVITY_RECEIPT_CONFIGURATION',
  GET_SALE_ACTIVITY_RECEIPT_CONFIGURATION_ENDED: 'GET_SALE_ACTIVITY_RECEIPT_CONFIGURATION_ENDED',
  UPDATE_SALE_ACTIVITY_RECEIPT_CONFIGURATION: 'UPDATE_SALE_ACTIVITY_RECEIPT_CONFIGURATION',
  UPDATE_SALE_ACTIVITY_RECEIPT_CONFIGURATION_ENDED:
    'UPDATE_SALE_ACTIVITY_RECEIPT_CONFIGURATION_ENDED',
  SEARCH_SALE_ACTIVITY_ORDERS: 'SEARCH_SALE_ACTIVITY_ORDERS',
  SEARCH_SALE_ACTIVITY_ORDERS_ENDED: 'SEARCH_SALE_ACTIVITY_ORDERS_ENDED',
  VOUCHER_SALE_ACTIVITY_ORDER_REFUND: 'VOUCHER_SALE_ACTIVITY_ORDER_REFUND',
  VOUCHER_SALE_ACTIVITY_ORDER_REFUND_ENDED: 'VOUCHER_SALE_ACTIVITY_ORDER_REFUND_ENDED',
  VOUCHER_SALE_ACTIVITY_ORDER_REFUND_BY_MANUALLY: 'VOUCHER_SALE_ACTIVITY_ORDER_REFUND_BY_MANUALLY',
  VOUCHER_SALE_ACTIVITY_ORDER_REFUND_BY_MANUALLY_ENDED:
    'VOUCHER_SALE_ACTIVITY_ORDER_REFUND_BY_MANUALLY_ENDED',
  VOUCHER_SALE_ACTIVITY_ORDER_PARTIALLY_REFUND: 'VOUCHER_SALE_ACTIVITY_ORDER_PARTIALLY_REFUND',
  VOUCHER_SALE_ACTIVITY_ORDER_PARTIALLY_REFUND_ENDED:
    'VOUCHER_SALE_ACTIVITY_ORDER_PARTIALLY_REFUND_ENDED',
  VOUCHER_SALE_ACTIVITY_ORDER_REJECT_REFUND_APPLICATION:
    'VOUCHER_SALE_ACTIVITY_ORDER_REJECT_REFUND_APPLICATION',
  VOUCHER_SALE_ACTIVITY_ORDER_REJECT_REFUND_APPLICATION_ENDED:
    'VOUCHER_SALE_ACTIVITY_ORDER_REJECT_REFUND_APPLICATION_ENDED',
  GET_REFUND_AMOUNT_INFO: 'GET_REFUND_AMOUNT_INFO',
  GET_REFUND_AMOUNT_INFO_ENDED: 'GET_REFUND_AMOUNT_INFO_ENDED',
  ISSUE_VOUCHER_SALE_ACTIVITY_ORDER: 'ISSUE_VOUCHER_SALE_ACTIVITY_ORDER',
  ISSUE_VOUCHER_SALE_ACTIVITY_ORDER_ENDED: 'ISSUE_VOUCHER_SALE_ACTIVITY_ORDER_ENDED',
  CREATE_CREDIT_BY_SALE_ACTIVITY_ORDER: 'CREATE_CREDIT_BY_SALE_ACTIVITY_ORDER',
  CREATE_CREDIT_BY_SALE_ACTIVITY_ORDER_ENDED: 'CREATE_CREDIT_BY_SALE_ACTIVITY_ORDER_ENDED',
  INVALIDATE_RECEIPT_BY_SALE_ACTIVITY_ORDER: 'INVALIDATE_RECEIPT_BY_SALE_ACTIVITY_ORDER',
  INVALIDATE_RECEIPT_BY_SALE_ACTIVITY_ORDER_ENDED:
    'INVALIDATE_RECEIPT_BY_SALE_ACTIVITY_ORDER_ENDED',
};

export default actions;
